jQuery(function($) {
  "use strict";

  // Loading Animations
  setTimeout(function() {
    setTimeout(function() {
      $("#home__hero h1").addClass("loaded");
    }, 150);
    setTimeout(function() {
      $("#home__hero .text").addClass("loaded");
    }, 300);
    setTimeout(function() {
      $("#home__hero .buttons__wrapper").addClass("loaded");
    }, 450);
    setTimeout(function() {
      $("#home__hero .hero__gallery-wrapper").addClass("loaded");
    }, 450);
    setTimeout(function() {
      $("#home__hero .hero__gallery-decoration").addClass("loaded");
    }, 550);
  }, 300);

  var overviewSeen = false;
  var marketsSeen = false;
  var productsAndSolutionsSeen = false;
  var newsAndInsightsSeen = false;
  var careersSeen = false;

  $(window).on("load scroll", function() {
    if (
      (vector.isScrolledIntoView("#home-overview .trigger__bottom") ||
        vector.isScrolledIntoView("#home-overview .trigger__top")) &&
      !overviewSeen
    ) {
      setTimeout(function() {
        $("#home-overview .overview__inner").addClass("loaded");
      }, 300);
      setTimeout(function() {
        $("#home-overview .overview__decoration").addClass("loaded");
      }, 900);
      overviewSeen = true;
    }

    if (
      (vector.isScrolledIntoView("#home-markets .trigger__bottom") ||
        vector.isScrolledIntoView("#home-markets .trigger__top")) &&
      !marketsSeen
    ) {
      setTimeout(function() {
        $("#home-markets").addClass("loaded");
      }, 300);
      marketsSeen = true;
    }

    if (
      (vector.isScrolledIntoView("#home-products-and-solutions .trigger__bottom") ||
        vector.isScrolledIntoView("#home-products-and-solutions .trigger__top")) &&
      !productsAndSolutionsSeen
    ) {
      setTimeout(function() {
        $("#home-products-and-solutions").addClass("loaded");
      }, 300);
      setTimeout(function() {
        $("#home-products-and-solutions .products-and-solutions__decoration").addClass("loaded");
      }, 900);
      productsAndSolutionsSeen = true;
    }

    if (
      (vector.isScrolledIntoView("#home-news-and-insights .trigger__bottom") ||
        vector.isScrolledIntoView("#home-news-and-insights .trigger__top")) &&
      !newsAndInsightsSeen
    ) {
      setTimeout(function() {
        $("#home-news-and-insights").addClass("loaded");
      }, 300);
      newsAndInsightsSeen = true;
    }

    if (
      (vector.isScrolledIntoView("#home-careers .trigger__bottom") ||
        vector.isScrolledIntoView("#home-careers .trigger__top")) &&
      !careersSeen
    ) {
      setTimeout(function() {
        $("#home-careers .careers__inner").addClass("loaded");
      }, 300);
      careersSeen = true;
    }
  });

  const $fadeGalleries = $(
    "#hero__gallery.init, #products-and-solutions__gallery.init",
  );

  $fadeGalleries.each(function() {
    const $gallery = $(this);

    if (!$gallery.hasClass("slick-initialized")) {
      $gallery.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        fade: true,
        cssEase: "linear",
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
      });
    }
  });

  vector.newsAndInsightsSlider();

  $(".products-and-solutions__category-form").on("submit", function(event) {
    const productCategory = $(this)
      .find('[name="product_cat"]')
      .val();

    if (!productCategory) {
      event.preventDefault();
      window.location.assign($(this).attr("data-shop-url"));
    }
  });
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/home.js